import $__ace_builds_src_noconflict_mode_javascript from "ace-builds/src-noconflict/mode-javascript";
import $__ace_builds_src_noconflict_ace from 'ace-builds/src-noconflict/ace';
import $____lib_ace_mode_electricimp_highlight_rules from "@/lib/ace/mode/electricimp_highlight_rules";

// load the javascript mode which contains cstyle helpers
$__ace_builds_src_noconflict_mode_javascript
var Ace = $__ace_builds_src_noconflict_ace;


var oop = Ace.require("ace/lib/oop");

// defines the parent mode
var TextMode = Ace.require("ace/mode/text").Mode;
var CStyleFoldMode = Ace.require("ace/mode/folding/cstyle").FoldMode;
var CstyleBehaviour = Ace.require("ace/mode/behaviour/cstyle").CstyleBehaviour;
var MatchingBraceOutdent = Ace.require("ace/mode/matching_brace_outdent").MatchingBraceOutdent;

// defines the language specific highlighters and folding rules
var ElectricImpHighlightRules = $____lib_ace_mode_electricimp_highlight_rules;

var Mode = function() {
    this.HighlightRules = ElectricImpHighlightRules;

    this.$outdent = new MatchingBraceOutdent();
    this.$behaviour = new CstyleBehaviour();
    this.foldingRules = new CStyleFoldMode();
};
oop.inherits(Mode, TextMode);


(function() {
    this.lineCommentStart = "//";
    this.blockComment = {start: "/*", end: "*/"};
    this.getNextLineIndent = function(state, line, tab) {
        var indent = this.$getIndent(line);

        var tokenizedLine = this.getTokenizer().getLineTokens(line, state);
        var tokens = tokenizedLine.tokens;
        var endState = tokenizedLine.state;
        var match;

        if (tokens.length && tokens[tokens.length-1].type == "comment") {
            return indent;
        }

        if (state == "start" || state == "no_regex") {
            match = line.match(/^.*(?:\bcase\b.*\:|[\{\(\[])\s*$/);
            if (match) {
                indent += tab;
            }
        } else if (state == "doc-start") {
            if (endState == "start" || endState == "no_regex") {
                return "";
            }
            match = line.match(/^\s*(\/?)\*/);
            if (match) {
                if (match[1]) {
                    indent += " ";
                }
                indent += "* ";
            }
        }

        return indent;
    };

    this.checkOutdent = function(state, line, input) {
        return this.$outdent.checkOutdent(line, input);
    };

    this.autoOutdent = function(state, doc, row) {
        this.$outdent.autoOutdent(doc, row);
    };

    this.$id = "lib/ace/mode/electricimp";
}).call(Mode.prototype);

export default Mode;


